export const DEFAULT_GAMER_NAME = 'Player1';
export const DEFAULT_SECOND_GAMER_NAME = 'Player2';

export const PLAYERS_ID = { FIRST_GAMER_ID: 0, SECOND_GAMER_ID: 1, BOT_ID: 2 };

export enum SecondPlayer {
  bot = 'bot',
  human = 'human',
}
